<template>
  <ModalDialog
    :model-value="show"
    persistent
    :title="t('Meetings.availability.deleteDialog.title')"
    max-width="480px"
    @closed="emit('confirm', false)"
  >
    <p class="text-body-m text-subtle">{{ t('Meetings.availability.deleteDialog.description') }}</p>
    <div class="mt-6 flex justify-end gap-3">
      <button class="btn-outline-neutral-s" data-testid="meetings-config-delete-cancel" @click="emit('confirm', false)">
        {{ t('Meetings.availability.deleteDialog.cancel') }}
      </button>
      <button class="btn-primary-destructive-s" data-testid="meetings-config-delete-confirm" @click="emit('confirm', true)">
        {{ t('Meetings.availability.deleteDialog.confirm') }}
      </button>
    </div>
  </ModalDialog>
</template>

<script setup lang="ts">
import { ModalDialog } from '@ramp106/omrjs-core-ui'
import { useI18n } from 'vue-i18n'

defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  (e: 'confirm', value: boolean): void
}>()

const { t } = useI18n()
</script>
